import styled from 'styled-components/native';

export const Container = styled.View<{ colors: string; angle: number }>`
  background-image: ${({ colors, angle }) =>
    `linear-gradient(${angle}deg, ${colors})`};
  flex: 1;
`;
